import { request } from "@/plugins/axios";
import wx from "weixin-js-sdk";
import { queryUrl, delUrlParams } from "@/utils/index";
import { isWeiXin } from "@/utils";
import store, { INIT_WX_INFO } from "../store";

/**
 * @desc 分享流程
 * 分享页面-->获取分享shareId-->生成网页授权地址-->传给app（shareId 和授权页面地址）-->app调用分享成功的接口 + 打开微信
 * 授权之后页面参数 tenantId，shareId, code, state
 * **/
/**
 * @desc 微信分享的配置
 * @type {{appid: string, scope: string, response_type: string, state: string}}
 * response_type 返回类型
 * scope: snsapi_base （不弹出授权页面，直接跳转，只能获取用户openid），snsapi_userinfo （弹出授权页面，可通过openid拿到昵称、性别、所在地。并且， 即使在未关注的情况下，只要用户授权，也能获取其信息 ）
 * state: wxShareState  重定向后会带上state参数，开发者可以填写a-zA-Z0-9的参数值，最多128字节
 */
const config = {
  appid: (function () {
    let appid = "wx8eb6a22994c58d1c"; // 线上
    let origin = location.origin;
    if (origin.indexOf("test-admin") > -1) {
      appid = "wx66b032344efdc423"; // test
    }
    if (origin.indexOf("test2-admin") > -1) {
      appid = "wxbce52dcb8aaf7b9e"; // test2
    }
    if (origin.indexOf("test3-admin") > -1) {
      appid = "wxcbfe278e75fffdab"; // test3
    }
    return appid;
  })(),
  response_type: "code",
  scope: "snsapi_userinfo",
  state: "wxShareState",
};
/**
 * @desc 微信网页授权
 * @param url 微信分享的url（授权之后跳转的地址）
 * @returns {string}
 */
export const createAuthUrl = (url) => {
  let { appid, response_type, scope, state } = config;
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(
    url
  )}&response_type=${response_type}&scope=${scope}&state=${state}#wechat_redirect`;
};
/**
 * @desc 新增厚予微信授权中间页
 * @param url 微信分享的url（授权之后跳转的地址）
 * @returns {string}
 */
export const houyuAuthUrl = (url) => {
  const wxUrl = createAuthUrl(url);
  return `${
    location.origin
  }/flagship-planner-h5/index.html#/wxAuth?target=${encodeURIComponent(wxUrl)}`;
};
/**
 * @desc 获取用户信息（网页授权之后，根据url参数）
 * @returns {Promise<*>} unionId，unionName，userId
 */
export const getUserInfo = async () => {
  const { code } = queryUrl(location.href);
  try {
    const res = await request({
      method: "post",
      url: "/houyu-information/h5/wcrmInteraction/getWechatInfoByAuthorizationCode",
      fetchLoading: false,
      needToken: false,
      data: {
        code,
      },
    });
    const { success, msg, data } = res;
    if (!success) {
      return Promise.reject(new Error(msg));
    }
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
};
/**
 * @desc 微信网页授权失败错误code描述
 * @type {{"10009": string, "10011": string, "10010": string, "10013": string, "10012": string, "10004": string, "10015": string, "10003": string, "10006": string, "10005": string, "10016": string}}
 */
// const errorCode = {
//   10003: "redirect_uri域名与后台配置不一致",
//   10004: "此公众号被封禁",
//   10005: "此公众号并没有这些scope的权限",
//   10006: "必须关注此测试号",
//   10009: "操作太频繁了，请稍后重试",
//   10010: "scope不能为空",
//   10011: "redirect_uri不能为空",
//   10012: "appid不能为空",
//   10013: "state不能为空",
//   10015: "公众号未授权第三方平台，请检查授权状态",
//   10016: "不支持微信开放平台的Appid，请使用公众号Appid",
// };
/**
 * @desc 获取新的首次分享的shareId
 * @returns {Promise<*>}
 */
export const getShareId = async (params) => {
  try {
    const res = await request({
      method: "post",
      url: "/houyu-information/h5/wcrmInteraction/getShareId",
      fetchLoading: false,
      data: {
        ...params,
      },
    });
    const { success, msg, data } = res;
    if (!success) {
      return Promise.reject(new Error(msg));
    }
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
};

/**
 * 微信网页授权
 * @returns {Promise<boolean>}
 */
export const wxWebAuthAsync = async (routerNext) => {
  if (!isWeiXin) {
    return true;
  }
  const { code, state } = queryUrl(location.href);
  // if (!code || !state) {
  //   location.href = createAuthUrl(location.href);
  //   return false;
  // }
  if ((!code || !state) && location.href.indexOf("wxAuth") === -1) {
    const wxUrl = createAuthUrl(location.href);
    if (routerNext) {
      await routerNext({
        name: "WxAuth",
        query: {
          target: wxUrl,
        },
        replace: true,
      });
    }
    // location.href = houyuAuthUrl(location.href);
    return false;
  }
  try {
    const userInfo = await getUserInfo();
    console.log("userInfo--");
    console.log(JSON.stringify(userInfo));
    if (userInfo) {
      store.commit({
        type: INIT_WX_INFO,
        wxInfo: userInfo,
      });
      // 授权成功
      window.localStorage.setItem("is_snapshotuser", userInfo.is_snapshotuser);
      // is_snapshotuser 1 是虚假信息 跳转终止； 0或null 流程继续
      if (userInfo.is_snapshotuser == 1) {
        location.replace(
          `${location.origin}/flagship-planner-h5/index.html#/wxError`
        );
        return false;
      }
    }
    if (
      new RegExp("^" + "\\?code=.+&state=" + config.state, "g").test(
        location.search
      )
    ) {
      let target = location.href.replace(
        new RegExp("\\" + location.search, "g"),
        ""
      );
      if (target.indexOf("?") > -1) {
        target += `&t=${new Date().getTime()}`;
      } else {
        target += `?t=${new Date().getTime()}`;
      }
      location.replace(target);
    }
    return true;
  } catch (e) {
    return true;
  }
};
/**
 * 微信SDK授权
 * 微信扩展功能初始化，包括二次分享
 * @param params
 * title: params.title, // 分享标题
 * desc: params.desc, // 分享描述
 * link: params.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
 * imgUrl: params.imgUrl, // 分享图标
 * forwardId：分享的目标链接
 * @returns {Promise<*>}
 */
export const wxSdkAuthAsync = async (params) => {
  try {
    if (!params.forwardId) {
      return Promise.reject("SDK初始化错误，缺少forwardId！");
    }
    const res = await request({
      method: "post",
      url: "/houyu-information/h5/wcrmInteraction/getShareTicket",
      fetchLoading: false,
      data: {
        url: location.href.split("#")[0],
      },
    });
    const { success, msg, data } = res;
    if (!success) {
      return Promise.reject(new Error(msg));
    }
    const { appId, timestamp, nonceStr, signature } = data;
    // 初始化wx
    // appId 公众号的唯一标识， timestamp 生成签名的时间戳， nonceStr 生成签名的随机串， signature 签名
    wx.config({
      debug: false,
      appId,
      timestamp,
      nonceStr,
      signature,
      jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline"],
    });
    // 净化 分享url
    let tempLink = params.link;
    tempLink = delUrlParams(tempLink, "shareId");
    tempLink = delUrlParams(tempLink, "forwardId");
    tempLink = delUrlParams(tempLink, "parentPvId");
    params.link = tempLink;
    // 拼上接口拿到的最新forwardId
    if (params.link.indexOf("?") > -1) {
      params.link += `&forwardId=${params.forwardId}&parentPvId=${params.parentPvId}`;
    } else {
      params.link += `?forwardId=${params.forwardId}&parentPvId=${params.parentPvId}`;
    }
    const shareOptions = {
      title: params.title, // 分享标题
      desc: params.desc, // 分享描述
      link: houyuAuthUrl(params.link), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: params.imgUrl, // 分享图标
      success: () => {
        shareSucCB(params.forwardId);
      },
    };
    wx.ready(function () {
      wx.onMenuShareAppMessage(shareOptions);
      wx.onMenuShareTimeline(shareOptions);
    });
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
};
/**
 * @desc 二次分享成功回调
 * @param forwardId
 * @returns {Promise<*>}
 */
const shareSucCB = async (forwardId) => {
  try {
    const res = await request({
      method: "post",
      url: "/houyu-information/h5/wcrmInteraction/notifyForwardSuccess",
      fetchLoading: false,
      needToken: false,
      data: {
        forwardId,
      },
    });
    const { success, msg, data } = res;
    if (!success) {
      return Promise.reject(new Error(msg));
    }
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
};
/**
 * 计算阅读时间
 * @returns {Promise<number>} 返回定时器id
 * @param params
 */
export const recordPvTime = async (unionId) => {
  const { shareId, forwardId, parentPvId } = queryUrl(location.href);
  try {
    if (!shareId && !forwardId) {
      return Promise.reject("初始化PV方法错误，缺少shareId和forwardId");
    }
    let sessinonRecordPv = window.sessionStorage.getItem("recordPv");
    if (sessinonRecordPv && sessinonRecordPv !== "null") {
      return Promise.reject("记录PV已经开始！");
    }
    const res = await request({
      method: "post",
      url: "/houyu-information/h5/wcrmInteraction/resourcePV",
      fetchLoading: false,
      needToken: false,
      data: {
        shareId,
        forwardId,
        unionId,
        parentPvId,
      },
    });
    const { success, msg, data } = res;
    if (!success) {
      return Promise.reject(new Error(msg));
    }
    const { pvId, radarId } = data;
    let duration = 5;
    let timer;
    if (pvId && radarId) {
      timer = setInterval(async function () {
        try {
          await request({
            url: "/houyu-information/h5/wcrmInteraction/recordPvTime",
            method: "post",
            fetchLoading: false,
            needToken: false,
            data: {
              pvId,
              duration,
              radarId,
            },
          });
        } catch (e) {
          clearInterval(timer);
          window.sessionStorage.removeItem("recordPv");
        }
      }, duration * 1000);
      window.sessionStorage.setItem("recordPv", timer);
    }
    return data;
  } catch (e) {
    return Promise.reject(e);
  }
};
/**
 * 初始化微信授权: pv + 二次分享内容
 * @param params
 * @returns {Promise<void>}
 */
export const wxAuthInitAsync = async (params) => {
  const wxInfo = store.state.wxInfo;
  if (!wxInfo) {
    console.log("未获得微信用户信息！");
    return;
  }
  try {
    const data = await recordPvTime(wxInfo.unionId);
    window.sessionStorage.setItem("readInfo", JSON.stringify(data));
    await wxSdkAuthAsync({
      ...params,
      forwardId: data.forwardId,
      parentPvId: data.pvId,
    });
  } catch (e) {
    console.log(e);
    return {};
  }
};

/*
 * 单纯页面的二次分享设置
 * */
export const wxShare = async (params) => {
  const res = await request({
    method: "post",
    url: "/houyu-information/h5/wcrmInteraction/getShareTicket",
    fetchLoading: false,
    data: {
      url: location.href.split("#")[0],
    },
  });
  const { appId, timestamp, nonceStr, signature } = res.data;
  // 初始化wx
  // appId 公众号的唯一标识， timestamp 生成签名的时间戳， nonceStr 生成签名的随机串， signature 签名
  wx.config({
    debug: false,
    appId,
    timestamp,
    nonceStr,
    signature,
    jsApiList: ["onMenuShareAppMessage", "onMenuShareTimeline"],
  });
  wx.ready(function () {
    wx.onMenuShareAppMessage(params);
    wx.onMenuShareTimeline(params);
  });
};
